import * as types from './types';

export const reducer = (state, action) => {
  switch (action.type) {
    case types.PAGINATION_GOPAGE: {
      return { ...state, currentPage: action.currentPage };
    }
  }

  return { ...state };
};
